//export const API_URL = 'http://localhost:8080'
export const API_URL = 'https://plesh-players-api-ktp7hje7ja-ew.a.run.app'
